module.exports = __webpack_public_path__ + "static/img/gerou.035f0201.png";